import React from 'react';

const LegalNotice = () => (
  <p className='legalExplanation'>
    Продолжая, вы соглашаетесь с{' '}
    <a href='/legal/privacy-policy' target='_blank' rel='noopener noreferrer'>
      политикой конфиденциальности
    </a>{' '}и{' '}
    <a href='/legal/terms-of-use' target='_blank' rel='noopener noreferrer'>
    условиями использования
    </a>
  </p>
);

export default LegalNotice;